<template>
  <div class="event-details-box">
    <div class="event-registration-box">
      <payment-summary :formTitle="eventConfig['names-label-your-total']" priceTitle="" :products="products" :donationPrice="donation"/>
    </div>
    <div class="event-form-wrap event-box-shadow">
    <div class="event-rg-form">
      <h6 class="mb-3">{{ eventConfig['payment-label-details'] }}</h6>
      <div class="form-payment">
        <div class="row">
          <div class="col-12" :class="classBtnGroup">
            <el-button-group class="toggle-options" v-if="showPaymentOptions">
              <template v-for="(payment, i) of paymentOptions">
                <el-button
                  :key="i"
                  :type="activePaymentIndex === i ? 'primary' : 'plain'"
                  @click="activePaymentIndex = i"
                  v-if="payment.active"
                >
                  {{ payment.name }}
                </el-button>
              </template>
            </el-button-group>
          </div>
        </div>
        <template v-if="paymentOptions.length">
          <keep-alive>
            <component
              :is="paymentOptions[activePaymentIndex].component"
              :billingInfo="billingInfo"
              :eventConfig="eventConfig"
              @back-step="onBackClick"
              @next-step="onNextClick"
            />
          </keep-alive>
        </template>
      </div>
    </div>
  </div>
  </div><!-- /.event-else-wrapper -->
</template>

<script>
import PaymentSummary from '../../_FormElements/PaymentSummary.vue';

import { mapGetters } from "vuex"

const CreditCard = () => import("./CreditCard.vue");
const SimpleCreditCard = () => import("./SimpleCreditCard.vue");
const BPay = () => import("./BPay.vue");
const Cash = () => import("./Cash.vue");
const Cheque = () => import("./Cheque.vue");

export default {
  components: {
    PaymentSummary
  },
  props: {
    tickets: { type: Array, required: true },
    eventConfig: { type: Object, required: true },
    billingInfo: { type: Object, required: true },
    userRoles: { type: [String, Object, Array] },
    participants: { type: [Object, Array], required: true }
  },
  data: function () {
    return {
      activePaymentIndex: 0,
      paymentOptions: [],
      showPaymentOptions: false,
      totalPrice: 0,
    }
  },
  mounted() {
    /*
    let staff = false;
    if(this.userRoles)
    {
      if(this.userRoles.constructor  === Array)
      {
        if(this.userRoles.indexOf('CHQStaff') >= 0)
        {
          staff = true;
        }
      }
    }
    this.setPaymentAvailability(staff);
    */
    this.setPaymentAvailability(this.userHasStaffPaymentTypes);
  },
  computed: {
    ...mapGetters('auth', ['userHasStaffPaymentTypes']),
    products: function () {
      return this.tickets.map(ticket => ({
        'product-code': ticket.code,
        'product-description': ticket.name,
        'total-price': ticket.total
      }));

    },
    classBtnGroup: function () {
      const activeCount = this.paymentOptions.filter(option => option.active).length;

      return {
        'col-md-6': activeCount === 2,
        'col-md-8': activeCount === 3,
        'col-md-10': activeCount >= 4
      };
    },
    
    donation: function(){
      if(this.participants)
      {
        return Number(this.participants.customDonation) + Number(this.participants.donation);
      }
      return 0
    },
    calcTotal() {
      const price = []
      let donationPrice = this.donation ? this.donation : 0
      this.products.forEach(product => {
        price.push(product['total-price'])
      })

      const total = price.reduce((a,b) => {
        if(a !== undefined && b !== undefined) {
          return parseInt(a) + parseInt(b)
        }
      }, 0)

      return total + donationPrice
    },
  },
  methods: {
    setPaymentAvailability(isStaff = false) {
      this.paymentOptions = [
        {
          name: "Credit Card",
          component: CreditCard,
          active: null,
        },
        {
          name: "BPAY",
          component: BPay,
          active: null,
        },
        {
          name: "Cash",
          component: Cash,
          active: null,
        },
        {
          name: "Cheque",
          component: Cheque,
          active: null,
        },
      ];

      let isCreditCardActive = true;
      let isSimpleCreditCard = false;
      let isBPayActive = this.eventConfig["allow-bpay-payment"];
      let isCashActive = !!(this.calcTotal <= 100 && this.eventConfig["allow-cash-payment"]);
      let isChequeActive = this.eventConfig["allow-cheque-payment"];

      if (isStaff) {
        isCreditCardActive = false;
        isBPayActive = false;
        isCashActive = false;
        isChequeActive = false;

        const staffPay = this.eventConfig["staff-payment-types"].split(",");
        staffPay.forEach((pay) => {
          pay = pay.trim();
          //cash, cheque, simplecreditcard, bpay
          switch (pay) {
            case "cash":
              if(this.calcTotal <= 100) {
                isCashActive = true;
              }
              break;
            case "cheque":
              isChequeActive = true;
              break;
            case "simplecreditcard":
              isSimpleCreditCard = true;
              break;
            case "bpay":
              isBPayActive = true;
              break;
            default:
              break;
          }
        });
      }

      this.paymentOptions.forEach((option) => {
          switch (option.name) {
            case "Credit Card":
              option.active = (isCreditCardActive || isSimpleCreditCard);
              if (isSimpleCreditCard) {
                option.component = SimpleCreditCard;
              }
              break;
            case "BPAY":
              option.active = isBPayActive;
              break;
            case "Cash":
              option.active = isCashActive;
              break;
            case "Cheque":
              option.active = isChequeActive;
              break;
            default:
              break;
          }
        });

      const activeCount = this.paymentOptions.filter(option => option.active).length;
      if (activeCount > 1) {
        this.showPaymentOptions = true;
      }
    },
    onBackClick: function (payload = 3) {
      this.$emit('next-step', { step: payload });
    },
    onNextClick: function (receiptInfo) {
      this.$emit('next-step', { step: 5, receiptInfo });
    }
  }
}
</script>

<style lang="scss" scoped>
.form-payment {
  margin-top: 20px;

  .el-button {
    width: 100%;
  }

  .el-button-group {
    display: flex;
/*
    .el-button {
      font-weight: normal;

      &.el-button--primary {
        background-color: #04adee;
        border: none;

        &:hover {
          background-color: #04adee;
          color: #fff;
        }
      }

      &:hover {
        background-color: #fff;
        color: #606266;
        border-color: #DCDFE6;
      }
    }

    */
  }
}
</style>
